module.exports = __webpack_public_path__ + "img/bar-chart.c0a041e6.svg";